// components/SuccessAlert.js
import React from 'react';
import { X } from 'lucide-react';

function SuccessAlert({ brand, onClose }) {
  return (
    <div className="fixed top-4 right-4 left-4 md:left-auto md:w-96 bg-blue-50 border-l-4 border-blue-500 rounded-lg shadow-lg p-4 z-50 animate-fadeIn">
      <div className="flex justify-between items-start">
        <div className="flex items-center">
          <div className="bg-white p-2 rounded-full">
            <svg className="w-6 h-6 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
          </div>
          <div className="ml-3">
            <h3 className="font-bold text-gray-800">Success!</h3>
            <div className="text-sm text-gray-600">
              You've claimed your welcome bonus at {brand.name}
            </div>
            <div className="mt-1 font-semibold text-blue-600">
              {brand.welcomeBonus}
            </div>
          </div>
        </div>
        <button 
          onClick={onClose}
          className="text-gray-700 hover:text-gray-900"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  );
}

export default SuccessAlert;